import ViewBase from "../views/view-base.view";
import { Checkbox } from "construct-ui";
import WidgetContainerComponent from "../components/widget/widget-container.component";
import SalesPerformanceChartComponent from "../components/charts/xy/sales-performance-chart.component";
import HomeDashboardModel from "../models/home/home-dashboard.model";
import PerformanceModel from "../models/task-management/performance.model";

export default function SalesPerformanceWidget() {
  ViewBase.call(this);

  let chartData;
  let retailDivList = []
  let selectedRetailDivList = [];
  let isDetails = false;
  let filter = { fromMonth: "", toMonth: "" };

  let onSearchDataChanged = (_inputFilter) => {
    if (_inputFilter) {
      filter.fromMonth = _inputFilter.fromMonth;
      filter.toMonth = _inputFilter.toMonth;
      if (_inputFilter.siteGroup != null && _inputFilter.siteGroup != "")
        filter.siteGroup = _inputFilter.siteGroup;
      if (_inputFilter.site != null && _inputFilter.site != "")
        filter.site = _inputFilter.site;
      if (_inputFilter.retailDiv != null && _inputFilter.retailDiv != "")
        filter.retailDiv = _inputFilter.retailDiv;
      if (_inputFilter.type != null && _inputFilter.type != "")
        filter.type = _inputFilter.type;
    }
    isDetails = true;
    chartData = null;
    retailDivList = [];
    selectedRetailDivList = [];
    getChartData();
  }

  let getChartData = function () {
    if (!isDetails) {
      HomeDashboardModel.getSalesPerformanceData(
        (result) => {
          chartData = result.saleDetails;

          if (retailDivList.length < 1) {
            result.retailDivDetails.forEach(o => {
              retailDivList.push(o.retailDiv);
              selectedRetailDivList.push(o.retailDiv);
            });
          } else {
            selectedRetailDivList = [];
            result.retailDivDetails.forEach(o => {
              selectedRetailDivList.push(o.retailDiv);
            });
          }
        }, (error) => {
          console.error('Error in getSalesPerformanceData()', JSON.stringify(error))
        },
        selectedRetailDivList
      );
    }
    else if (isDetails) {
      if (selectedRetailDivList && selectedRetailDivList.length > 0) {
        filter.retailDiv = selectedRetailDivList.join("^");
      }
      else {
        filter.retailDiv = "";
      }

      PerformanceModel.getSalesPerformances(filter)
      .then((result) => {
        chartData = result.saleDetails;

        if (retailDivList.length < 1) {
          result.retailDivDetails.forEach(o => {
            retailDivList.push(o.retailDiv);
            selectedRetailDivList.push(o.retailDiv);
          });
        } else {
          selectedRetailDivList = [];
          result.retailDivDetails.forEach(o => {
            selectedRetailDivList.push(o.retailDiv);
          });
        }
      })
      .catch((error) => {
        console.error('Error in getSalesPerformances()', JSON.stringify(error))
      });
    }
  }

  let onSelectedRetailDivChanged = (e) => {
    var div = e.target.dataset.value;
    if (e.target.checked && !selectedRetailDivList.includes(div)) {
      selectedRetailDivList.push(div);
    } else if (!e.target.checked && selectedRetailDivList.includes(div)) {
      selectedRetailDivList = selectedRetailDivList.filter(d => d !== div);
    }
    // Reset
    chartData = null;
    getChartData();
  }

  return {
    oninit: (vnode) => {
      isDetails = vnode.attrs.isDetails;
      if (vnode.attrs.inputFilter) {
        filter.fromMonth = vnode.attrs.inputFilter.fromMonth;
        filter.toMonth = vnode.attrs.inputFilter.toMonth;
      }
      if (vnode.attrs.events) {
        vnode.attrs.events.onSearchDataChanged = onSearchDataChanged;
      }
      getChartData();
    },
    view: (vnode) => {
      return [
        m(WidgetContainerComponent,
          {
            title: isDetails ? "" : this.getText('LT00000112', 'Sales Performance'),
            links: [
              {
                text: isDetails ? "" : this.getText('LT00000108', 'Details'),
                url: isDetails ? "" : '/performance'
              }
            ],
            class: vnode.attrs.class,
            style: vnode.attrs.style,
          }, [
          m('.row', [
            m('.col-md-12',
              m('.card.widget-component', m('.card-body',
                m('.row', [
                  m('.col-md-10', { style: "height: 250px;" },
                    chartData &&
                    m(SalesPerformanceChartComponent, { data: chartData }),
                  ),
                  m('.col-md-2',
                    m('.d-flex.flex-md-column.justify-content-center.mt-4.mt-md-0', { style: "gap: 1.5em; height: 100%;" }, [
                      retailDivList &&
                      retailDivList.map((div) => [
                        m(Checkbox, {
                          label: div,
                          'data-value': div,
                          checked: selectedRetailDivList.includes(div),
                          onchange: onSelectedRetailDivChanged,
                        }),
                      ]),
                    ]),
                  ),
                ]),
              )),
            ),
          ]),
        ]
        ),
      ]
    }
  }
}
